import { Component, input, model, output, signal } from '@angular/core';
import { CheckboxModule } from 'primeng/checkbox';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslationPipe } from 'src/app/pipes/translation/translation-pipe';

@Component({
  selector: 'app-preview-node',
  imports: [CheckboxModule, CommonModule, FormsModule, TranslationPipe],
  templateUrl: './preview-node.html',
  styleUrl: './preview-node.scss'
})
export class PreviewNode {
  node = input<any>({});
  selectedStep = model<any | null>(null);
  onStepClickEvent = output<any>();
  isFirstLayer = input<boolean>();
  showCheckbox = input<boolean>();
  hasExpandableNodes = input<boolean>();

  onNodeClick(node: any, event: Event) {
    // event.stopPropagation();
    node.expanded = !node.expanded;
  }

  onStepClick(event: Event, node?: any) {
    if (this.showCheckbox()) return;

    if (node) {
      // event.stopPropagation();
      this.selectedStep.set(node);
      this.onStepClickEvent.emit(node);
    } else {
      this.onStepClickEvent.emit(event);
    }
  }

  checkFirstLayer(node: any) {
    if (!this.isFirstLayer()) return false;
    if (!node.children) return false;
    if (node.children.length === 0) return false;
    if (!node.children[0].children) return false;
    if (node.children[0].children.length === 0) return false;

    return true;
  }

  onParentCheckboxChange(event: any, parent: any) {
    if (parent.children && parent.children.length > 0) {
      parent.children.forEach((child: any) => (child.checked = parent.checked));
    }
  }

  areAllChildrenChecked(parent: any) {
    parent.checked = parent.children.every((child: any) => child.checked);
  }
}
